import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/booktoday.png'


const _withScopeId = n => (_pushScopeId("data-v-d7f05be2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Book Today! JtelFiber"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle-1 mt-n1" }, "Smart Fiber Internet with Jtel")
], -1))
const _hoisted_2 = { class: "mt-3 d-flex justify-center image-holder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, { src: _imports_0 }),
      _createVNode(_component_v_btn, { class: "btn-primary on-image booktoday" }, {
        default: _withCtx(() => [
          _createTextVNode("Book Jtel Fiber")
        ]),
        _: 1
      })
    ])
  ], 64))
}